/**
 * Color Utilities for Theme-Aware Colors
 *
 * Provides utilities to get computed colors from CSS custom properties,
 * enabling dynamic theming support.
 */

import { VariantType } from "../components/ContentCard/contentCardTypes";

/**
 * Gets the computed value of a CSS custom property
 */
export const getComputedColor = (property: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
};

/**
 * Chart color utilities for data visualization
 */
export const chartColors = {
  /** Single color for lesson/percentage charts */
  getLessonChartColor: (): string => getComputedColor("--indigo-700"),

  /** Multiple colors for dojo/activity charts */
  getDojoChartColors: (): string[] => [
    getComputedColor("--mauve-700"),
    getComputedColor("--teal-700"),
    getComputedColor("--blue-700"),
  ],
} as const;

export const levelToVariant = (levelId: number): VariantType => {
  switch (levelId) {
    case 2:
      return "teal";
    case 3:
      return "blue";
    case 1:
    case 5:
      return "mauve";
    case 4:
    default:
      return "indigo";
  }
};
